import React, { useCallback, useMemo } from "react";
import {TextField} from "@material-ui/core";
import {FieldAttributes, useField, useFormikContext} from "formik";
import "./index.scss";
import _ from 'lodash';
interface Props {
    label: string;
    disabled: boolean;
    hidden: boolean;
    error?: boolean;
    errorMessage?: string;
    backEndName?: string;
    setFieldToUpdate?: (fieldToUpdate: any) => void;
    onChangeListener?: (val: any) => void
    type:any;
    listenerDependency?: any
}

export const InputTextOld = (props: FieldAttributes<Props>) => {
    const {name, placeholder} = props;
    const {label, disabled, hidden, error, errorMessage, backEndName, setFieldToUpdate, type, onChangeListener} = props;
    const [field, meta, helpers] = useField({name});

    let fieldValue = field.value ? field.value : '';

    const validationError = meta.error && meta.touched ? meta.error : "";

    const helperText = useMemo(() => {
        if (validationError !== '') return validationError;
        if (error) return errorMessage;
        return "";
    }, [validationError, error, errorMessage]);

    const {handleBlur} = useFormikContext();
  
    const handleChange = (event: any) => {
      helpers.setValue(event.target.value);
      if(onChangeListener){
        onChangeListener(event.target.value);
      }
      debounce(event.target.value);
    };
  
    const debounce = useCallback(
      _.debounce((_searchVal: string) => {
        helpers.setValue(_searchVal);
        if(setFieldToUpdate && backEndName){
          setFieldToUpdate({name: backEndName, value: _searchVal});
      }
      onChangeListener?.(_searchVal);
      }, 500),
      [props.listenerDependency]
    );

    return (
        <div className={'input-text'}>
            <TextField
            autoComplete="off"
            inputProps={{autocomplete: 'new-password',
            form: {
              autocomplete: 'off',
            },
          }}
            onChange={handleChange} 
                       type={type}
                       id={name}
                       onBlur={handleBlur}
                       error={error || validationError !== ''}
                       fullWidth={true}
                       InputLabelProps={{
                           style: {
                               textOverflow: 'ellipsis',
                               whiteSpace: 'nowrap',
                               overflow: 'hidden',
                               width: '92%'
                           } }}
                       disabled={disabled}
                       hidden={hidden}
                       helperText={helperText}
                       value={fieldValue} 
                       variant={"outlined"}
                       label={label}
                       placeholder={placeholder}
            />
        </div>
    )
};
